import React, { useState, useEffect } from "react";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import makeRequest from "../../../utils/makeRequest";
import * as urls from "../../../utils/URLConst";
import toastNotify from "../../../utils/ToastNotify";
import { Button, Col, Modal, Row } from "react-bootstrap";
import moment from "moment";
import SelectField from "../../textField/SelectField";
import TextField from "../../textField/TextField";
import AddProductModal from "./AddProductModal";
import AddCompanyMdl from "./AddCompanyMdl";
import { handleLoader } from "../../../redux/reducers/layout";
import { useDispatch } from "react-redux";


const AddNewVenderModal = ({
  isOpen,
  handleReminder,
  fetchClientVenderDetail,
  editedData,
  setTranCodeData
}) => {

  const isEdit = editedData;
  const [productList, setProductList] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [isProductMdl, setIsProductMdl] = useState(false);
  const [isCompanyMdl, setIsCompanyMdl] = useState(false);
  const dispatch = useDispatch();

  const handleIsProductMdl = () => {
    setIsProductMdl(!isProductMdl);
  }

  const handleIsCompanyMdl = () => {
    setIsCompanyMdl(!isCompanyMdl);
  }


  const fetchCompanyList = async () => {
    try {
      dispatch(handleLoader(true));
      const data = {};
      const config = {};

      await makeRequest("POST", urls.getClientVederName, data, config).then(
        (result) => {
          if (result.STATUS === "0") {
            const response = result.RESPONSE;
            setCompanyList(response);
          } else {
            result.MESSAGE !== "Not found!" && toastNotify(result.MESSAGE, "error");
          }
        }
      );
    } catch (error) {
      // Ignore Case
    } finally {
      dispatch(handleLoader(false));
    }
  };

  const fetchProductList = async () => {
    try {
      dispatch(handleLoader(true));
      const data = {};
      const config = {};

      await makeRequest("POST", urls.getClientVederProduct, data, config).then(
        (result) => {
          if (result.STATUS === "0") {
            const response = result.RESPONSE;
            setProductList(response);
          } else {
            result.MESSAGE !== "Not found!" && toastNotify(result.MESSAGE, "error");
          }
        }
      );
    } catch (error) {
      // Ignore Case
    } finally {
      dispatch(handleLoader(false));
    }
  };



  async function addReminder(val) {
    try {
      dispatch(handleLoader(true));
      const config = {};
      var payload = {
        COMPANY_CD: val.companyName,
        PRODUCT_CD: val.product,
        PRODUCT_QTY: val.productQty,
        PRODUCT_PRICE: val.renewalPrice !== "" ? val.renewalPrice : "0.00",
        START_DT: val.startDate,
        END_DT: val.endDate,
        REM_MOBILE: val.contactNo,
        REM_EMAIL: val.emailId,
        REM_DAYS: val.renewaldays,
      };

      const result = await makeRequest(
        "POST",
        urls.setClientVeder,
        payload,
        config
      );

      if (result.STATUS === "0") {
        toastNotify(result.MESSAGE, "success");
        handleReminder();
        setTranCodeData(null);
        fetchClientVenderDetail();
      } else if (result.STATUS !== "0") {
        toastNotify(result.MESSAGE, "error");
      }
    } catch (error) {
      // Ingore Case
    } finally {
      dispatch(handleLoader(false));
    }
  }

  useEffect(() => {
    (async () => {
      await fetchProductList();
      await fetchCompanyList();
    })();
  }, []);


  async function editReminder(val) {
    try {
      dispatch(handleLoader(true));
      const config = {};
      var payload = {
        COMPANY_CD: val.companyName,
        PRODUCT_CD: val.product,
        PRODUCT_QTY: val.productQty,
        PRODUCT_PRICE: val.renewalPrice !== "" ? val.renewalPrice : "0.00",
        START_DT: val.startDate,
        END_DT: val.endDate,
        REM_MOBILE: val.contactNo,
        REM_EMAIL: val.emailId,
        REM_DAYS: val.renewaldays,
        VENDOR_TRAN_CD: editedData?.TRAN_CD,
      };
      const result = await makeRequest("POST", urls.updateClientVender, payload, config);

      if (result.STATUS === "0") {
        toastNotify(result.MESSAGE, "success");
        handleReminder();
        setTranCodeData(null);
        fetchClientVenderDetail();
      } else {
        toastNotify(result.MESSAGE, "error");
      }
    } catch (error) {
      // Ingore Case
    } finally {
      dispatch(handleLoader(false));
    }
  }

  const initialVal = {
    companyName: isEdit ? editedData.COMPANY_CD : "",
    companyLabel: isEdit ? editedData.COMPANY_NM : "",
    product: isEdit ? editedData.PRODUCT_CD : "",
    productLabel: isEdit ? editedData.PRODUCT_NM : "",
    productQty: isEdit ? editedData.PRODUCT_QTY : "",
    renewalPrice: isEdit ? editedData.PRODUCT_PRICE : "",
    startDate: isEdit ? editedData?.START_DT
      ? moment(editedData?.START_DT, "DD-MMM-YYYY").format("YYYY-MM-DD")
      : "" : "",
    endDate: isEdit ? editedData?.END_DT
      ? moment(editedData?.END_DT, "DD-MMM-YYYY").format("YYYY-MM-DD")
      : "" : "",
    contactNo: isEdit ? editedData.REM_MOBILE : "",
    emailId: isEdit ? editedData.REM_EMAIL : "",
    renewaldays: isEdit ? editedData.REM_DAYS : "",
  };

  const validationSchema = Yup.object().shape({
    companyName: Yup.string().required("Company is required field"),
    product: Yup.string().required("Product is required field"),
    contactNo: Yup.string().required("Contact no. is required field").min(10, "Contact no. must not exceed 10 digits").max(10, "Contact no. must not exceed 10 digits"),
    emailId: Yup.string().required("Email Id is required field").matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/, "Invalid email id"),
    startDate: Yup.string().required("Order date is required field"),
    endDate: Yup.string().required("Expiry date is required field"),
    productQty: Yup.string().required("Product Qty. is required field"),
    renewaldays: Yup.string().required("Renewal Days is required field"),
  });


  return (
    <>
      <Modal
        backdrop="static"
        keyboard={false}
        size="lg"
        show={isOpen}
        onHide={handleReminder}
      >
        <Modal.Header closeButton>
          <Modal.Title>{isEdit ? "Edit" : "Add"} Reminder</Modal.Title>
        </Modal.Header>

        <Formik
          enableReinitialize={true}
          initialValues={initialVal}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            if (isEdit) {
              editReminder(values)
            } else {
              addReminder(values)
            }
          }}
        >
          {({ setFieldValue, values, handleChange, handleBlur, setFieldTouched }) => (
            <Form>
              <Modal.Body>
                <Row>
                  <Col md={6}>
                    <SelectField
                      name="product"
                      tabIndex={2}
                      options={[
                        { value: "", label: "Select Product" },
                        ...productList.map((product) => ({
                          label: product.ITEM_NM,
                          value: product.ITEM_CD,
                        }))]}
                      required
                      placeholder="Product"
                      value={values.product !== "" && {
                        value: values.product,
                        label: values.productLabel
                      }}
                      onChange={(e) => {
                        setFieldValue("product", e?.value);
                        setFieldValue("productLabel", e?.label);
                      }}
                      onBlur={() => {
                        setFieldTouched("product", true);
                      }}
                    />
                    <ErrorMessage
                      name="product"
                      className="error-msg"
                      component="div"
                    />
                    <div className="text-end mt-1 text-sm text-primary cursor-pointer" onClick={handleIsProductMdl}>Add Product</div>
                  </Col>
                  <Col md={6} className="mt-md-0 mt-3">
                    <SelectField
                      name="customers"
                      tabIndex={2}
                      options={[
                        { value: "", label: "Select Company" },
                        ...companyList.map((company) => ({
                          label: company.VENDOR_NM,
                          value: company.VENDOR_CD,
                        }))]}
                      required
                      placeholder="Company"
                      value={values.companyName !== "" && {
                        value: values.companyName,
                        label: values.companyLabel
                      }}
                      onChange={(e) => {
                        setFieldValue("companyName", e?.value);
                        setFieldValue("companyLabel", e?.label);
                      }}
                      onBlur={() => {
                        setFieldTouched("companyName", true);
                      }}
                    />
                    <ErrorMessage
                      name="companyName"
                      component="div"
                      className="error-msg"
                    />
                    <div className="text-end mt-1 text-sm text-primary cursor-pointer" onClick={handleIsCompanyMdl}>Add Company</div>
                  </Col>
                  <Col md={3} className="mt-3">
                    <TextField
                      label="Quantity"
                      name="productQty"
                      id="productQty"
                      required
                      maxLength={6}
                      value={values.productQty}
                      onChange={(e) => {
                        e.preventDefault();
                        const { value } = e.target;
                        const regex = /^[0-9]*[.,]?[0-9]*$/;
                        if (regex.test(value.toString())) {
                          setFieldValue("productQty", value);
                        }
                      }}
                      onBlur={handleBlur}
                    />
                    <ErrorMessage
                      name="productQty"
                      component="div"
                      className="error-msg"
                    />
                  </Col>

                  <Col md={3} className="mt-3">
                    <TextField
                      label="Renewal Price"
                      name="renewalPrice"
                      id="renewalPrice"
                      style={{ textAlign: "right" }}
                      maxLength={10}
                      value={values.renewalPrice}
                      onChange={(e) => {
                        e.preventDefault();
                        const { value } = e.target;
                        const regex = /^[0-9]*[.,]?[0-9]*$/;
                        if (regex.test(value.toString())) {
                          setFieldValue("renewalPrice", value);
                        }
                      }}
                      onBlur={handleBlur}
                    />

                    <ErrorMessage
                      name="renewalPrice"
                      component="div"
                      className="error-msg"
                    />
                  </Col>

                  <Col md={3} className="mt-3">
                    <TextField
                      type="date"
                      label=" Order Date"
                      name="startDate"
                      id="startDate"
                      required
                      value={values.startDate}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    <ErrorMessage
                      name="startDate"
                      component="div"
                      className="error-msg"
                    />
                  </Col>

                  <Col md={3} className="mt-3">
                    <TextField
                      type="date"
                      label="Expiry Date"
                      name="endDate"
                      id="endDate"
                      required
                      value={values.endDate}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    <ErrorMessage
                      name="endDate"
                      component="div"
                      className="error-msg"
                    />
                  </Col>

                  <Col md={12} className="mt-4">
                    <fieldset className="fieldset mb-2">
                      <legend
                        className="fieldset-legend"
                        style={{
                          width: "auto",
                        }}
                      >
                        Reminder Notification
                      </legend>
                      <Row>
                        <Col md={6}>
                          <TextField
                            label="Renewal before days"
                            name="renewaldays"
                            id="renewaldays"
                            required
                            maxLength={5}
                            value={values.renewaldays}
                            onChange={(e) => {
                              e.preventDefault();
                              const { value } = e.target;
                              const regex = /^[0-9]*[.,]?[0-9]*$/;
                              if (regex.test(value.toString())) {
                                setFieldValue("renewaldays", value);
                              }
                            }}
                            onBlur={handleBlur}
                          />

                          <ErrorMessage
                            name="renewaldays"
                            component="div"
                            className="error-msg"
                          />
                        </Col>

                        <Col md={6} className="mt-md-0 mt-3">
                          <TextField
                            label="Contact No"
                            name="contactNo"
                            id="contactNo"
                            required
                            maxLength={10}
                            value={values.contactNo}
                            onChange={(e) => {
                              e.preventDefault();
                              const { value } = e.target;
                              const regex = /^[0-9]*[.,]?[0-9]*$/;
                              if (regex.test(value.toString())) {
                                setFieldValue("contactNo", value);
                              }
                            }}
                            onBlur={handleBlur}
                          />

                          <ErrorMessage
                            name="contactNo"
                            component="div"
                            className="error-msg"
                          />
                        </Col>

                        <Col md={6} className="mt-3">
                          <TextField
                            label="Email Id"
                            type="email"
                            name="emailId"
                            id="emailId"
                            required
                            maxLength={50}
                            value={values.emailId}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />

                          <ErrorMessage
                            name="emailId"
                            component="div"
                            className="error-msg"
                          />
                        </Col>
                      </Row>
                    </fieldset>
                  </Col>
                </Row>
                <div className="mt-3">
                  <div className="text-sm fw-bold text-danger">Note :-</div>
                  <ol className="mb-0">
                    <li className="text-sm">This feature automatically sends email reminders before the renewal days, notifying users about the upcoming expiration of their product or service.</li>
                  </ol>
                </div>
              </Modal.Body>
              <Modal.Footer className="py-2">
                <Button
                  type="submit"
                  variant="primary"
                  className=" btn-sm"
                >
                  {isEdit ? "Update" : "Submit"}
                </Button>
                <Button
                  type="button"
                  variant="secondary"
                  className="btn-sm"
                  onClick={() => { handleReminder(); setTranCodeData(null); }}
                  data-dismiss="modal"
                >
                  Cancel
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>


      </Modal >

      {isProductMdl &&
        <AddProductModal
          isOpen={isProductMdl}
          handleIsProductMdl={handleIsProductMdl}
          fetchProductList={fetchProductList}
        />
      }

      {
        isCompanyMdl &&
        <AddCompanyMdl
          isOpen={isCompanyMdl}
          handleIsCompanyMdl={handleIsCompanyMdl}
          fetchCompanyList={fetchCompanyList}
        />
      }
    </>
  );
};
export default AddNewVenderModal;
